import React from 'react';
import { Link } from 'react-router-dom';
import { Stethoscope, Clock, Users, Award, ArrowRight } from 'lucide-react';
import './Home.css';

const Home = () => {
  const stats = [
    { icon: <Award size={20} />, value: '15+', label: 'Years Experience' },
    { icon: <Users size={20} />, value: '50k+', label: 'Happy Patients' },
    { icon: <Stethoscope size={20} />, value: '25+', label: 'Expert Doctors' },
    { icon: <Clock size={20} />, value: '99%', label: 'Success Rate' },
  ];

  return (
    <div className="home">
      {/* HERO SECTION */}
      <section className="hero">
        <div className="hero-left">
          <div className="hero-badge">
            <Stethoscope size={16} />
            Trusted Healthcare Partner
          </div>
          <h1>Your Health, <span>Our Priority</span></h1>
          <p>Experience world-class medical care with cutting-edge technology and compassionate doctors. Your wellness journey starts here at RV Clinic.</p>
          <div className="hero-btns">
            <Link to="/contact" className="btn-primary">
              Book Appointment <ArrowRight size={18} />
            </Link>
            <Link to="/services" className="btn-secondary">Our Services</Link>
          </div>
          <div className="hero-stats">
            {stats.map((stat, i) => (
              <div className="stat" key={i}>
                <h3>{stat.value}</h3>
                <p>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-img-frame">
            <img src="https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=600&h=800&fit=crop" alt="Doctor" />
          </div>
          <div className="hero-float-card float-card-1">
            <div className="float-icon"><Stethoscope size={20} /></div>
            <div className="float-text">
              <h4>Expert Doctors</h4>
              <p>25+ Specialists</p>
            </div>
          </div>
          <div className="hero-float-card float-card-2">
            <div className="float-icon"><Clock size={20} /></div>
            <div className="float-text">
              <h4>24/7 Available</h4>
              <p>Emergency Care</p>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURED SERVICES PREVIEW */}
      <section className="section featured-services">
        <div className="section-header">
          <h2>Our Medical Services</h2>
          <p>Comprehensive healthcare solutions tailored to your needs</p>
        </div>
        <div className="services-preview-grid">
          {[
            { icon: '❤️', title: 'Cardiology', desc: 'Advanced heart care with state-of-the-art diagnostic facilities.' },
            { icon: '🦴', title: 'Orthopedics', desc: 'Complete bone and joint care including joint replacement.' },
            { icon: '🧠', title: 'Neurology', desc: 'Expert care for brain, spine, and nervous system disorders.' },
          ].map((s, i) => (
            <div className="service-card" key={i}>
              <div className="service-icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
        <div className="text-center" style={{ marginTop: '32px' }}>
          <Link to="/services" className="btn-secondary">View All Services</Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
